import * as Yup from "yup";

const familiaProdutosValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
});

export default familiaProdutosValidator;
